import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "space-y-4" }
const _hoisted_2 = { class: "text-center mb-4" }
const _hoisted_3 = { class: "text-xl font-bold text-gray-900 mb-1" }
const _hoisted_4 = { class: "text-sm text-gray-600" }
const _hoisted_5 = { class: "bg-gradient-to-br from-gray-50 to-blue-50 rounded-xl p-6 space-y-4 shadow-lg border border-gray-100" }
const _hoisted_6 = { class: "bg-white rounded-lg py-3 px-4 shadow-sm border border-gray-200" }
const _hoisted_7 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2" }
const _hoisted_8 = { class: "flex items-center space-x-2 py-1 px-2 bg-gray-50 rounded-md" }
const _hoisted_9 = { class: "min-w-0" }
const _hoisted_10 = { class: "font-medium text-gray-900 text-sm truncate" }
const _hoisted_11 = { class: "flex items-center space-x-2 py-1 px-2 bg-gray-50 rounded-md" }
const _hoisted_12 = { class: "min-w-0" }
const _hoisted_13 = { class: "font-medium text-gray-900 text-sm truncate" }
const _hoisted_14 = { class: "flex items-center space-x-2 py-1 px-2 bg-gray-50 rounded-md" }
const _hoisted_15 = { class: "min-w-0" }
const _hoisted_16 = { class: "font-medium text-gray-900 text-sm truncate" }
const _hoisted_17 = { class: "flex items-center space-x-2 py-1 px-2 bg-gray-50 rounded-md" }
const _hoisted_18 = { class: "min-w-0" }
const _hoisted_19 = { class: "font-medium text-gray-900 text-sm truncate" }
const _hoisted_20 = { class: "flex items-center space-x-2 py-1 px-2 bg-gray-50 rounded-md" }
const _hoisted_21 = { class: "min-w-0" }
const _hoisted_22 = { class: "font-medium text-gray-900 text-sm truncate" }
const _hoisted_23 = { class: "flex items-center space-x-2 py-1 px-2 bg-gray-50 rounded-md" }
const _hoisted_24 = { class: "min-w-0" }
const _hoisted_25 = { class: "font-medium text-gray-900 text-sm truncate" }
const _hoisted_26 = { class: "flex items-center space-x-2 py-1 px-2 bg-gray-50 rounded-md" }
const _hoisted_27 = { class: "min-w-0" }
const _hoisted_28 = { class: "font-medium text-gray-900 text-sm truncate" }
const _hoisted_29 = { class: "flex items-center space-x-2 py-1 px-2 bg-gray-50 rounded-md" }
const _hoisted_30 = { class: "min-w-0" }
const _hoisted_31 = { class: "font-medium text-gray-900 text-sm truncate" }
const _hoisted_32 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_33 = { class: "bg-white rounded-lg py-3 px-4 shadow-sm border border-gray-200" }
const _hoisted_34 = {
  key: 0,
  class: "flex items-center space-x-3"
}
const _hoisted_35 = ["src", "alt"]
const _hoisted_36 = { class: "space-y-1 min-w-0" }
const _hoisted_37 = { class: "text-sm font-medium text-gray-900 truncate" }
const _hoisted_38 = { class: "text-xs text-gray-600" }
const _hoisted_39 = {
  key: 1,
  class: "text-center py-4"
}
const _hoisted_40 = { class: "bg-white rounded-lg py-3 px-4 shadow-sm border border-gray-200" }
const _hoisted_41 = { class: "grid grid-cols-1 md:grid-cols-2 gap-2" }
const _hoisted_42 = { class: "flex items-center space-x-2 py-1 px-2 bg-gray-50 rounded-md" }
const _hoisted_43 = { class: "min-w-0" }
const _hoisted_44 = { class: "font-medium text-gray-900 text-sm truncate" }
const _hoisted_45 = { class: "flex items-center space-x-2 py-1 px-2 bg-gray-50 rounded-md" }
const _hoisted_46 = { class: "min-w-0" }
const _hoisted_47 = { class: "font-medium text-gray-900 text-sm truncate" }
const _hoisted_48 = { class: "flex items-center space-x-2 py-1 px-2 bg-gray-50 rounded-md" }
const _hoisted_49 = { class: "min-w-0" }
const _hoisted_50 = { class: "font-medium text-gray-900 text-sm truncate" }
const _hoisted_51 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_52 = { class: "bg-white rounded-lg py-3 px-4 shadow-sm border border-gray-200" }
const _hoisted_53 = { class: "space-y-2" }
const _hoisted_54 = { class: "flex items-center space-x-2 py-1 px-2 bg-gray-50 rounded-md" }
const _hoisted_55 = { class: "min-w-0" }
const _hoisted_56 = { class: "font-medium text-xs text-gray-900 truncate" }
const _hoisted_57 = { class: "flex items-center space-x-2 py-1 px-2 bg-gray-50 rounded-md" }
const _hoisted_58 = { class: "min-w-0" }
const _hoisted_59 = { class: "font-mono text-xs text-gray-900 truncate" }
const _hoisted_60 = { class: "flex items-center space-x-2 py-1 px-2 bg-gray-50 rounded-md" }
const _hoisted_61 = { class: "min-w-0" }
const _hoisted_62 = { class: "font-mono text-xs text-gray-900 truncate" }
const _hoisted_63 = { class: "bg-white rounded-lg py-3 px-4 shadow-sm border border-gray-200" }
const _hoisted_64 = { class: "space-y-2" }
const _hoisted_65 = { class: "flex items-center space-x-2 py-1 px-2 bg-gray-50 rounded-md" }
const _hoisted_66 = { class: "min-w-0" }
const _hoisted_67 = { class: "font-medium text-gray-900 text-sm truncate" }
const _hoisted_68 = { class: "flex items-center space-x-2 py-1 px-2 bg-gray-50 rounded-md" }
const _hoisted_69 = { class: "min-w-0" }
const _hoisted_70 = { class: "font-medium text-gray-900 text-sm truncate" }
const _hoisted_71 = { class: "flex items-center space-x-2 py-1 px-2 bg-gray-50 rounded-md" }
const _hoisted_72 = { class: "min-w-0" }
const _hoisted_73 = { class: "font-medium text-gray-900 text-sm truncate" }
const _hoisted_74 = { class: "bg-white rounded-lg py-3 px-4 shadow-sm border border-gray-200" }
const _hoisted_75 = { class: "grid grid-cols-1 md:grid-cols-2 gap-3" }
const _hoisted_76 = { class: "flex items-center justify-between p-3 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg border border-blue-200" }
const _hoisted_77 = { class: "flex items-center space-x-3" }
const _hoisted_78 = { class: "min-w-0" }
const _hoisted_79 = { class: "text-xs text-blue-700 truncate" }
const _hoisted_80 = {
  key: 0,
  class: "px-2 py-1 bg-gradient-to-r from-green-500 to-emerald-500 text-white text-xs font-medium rounded-full"
}
const _hoisted_81 = { class: "flex items-center justify-between p-3 bg-gradient-to-r from-green-50 to-emerald-50 rounded-lg border border-green-200" }
const _hoisted_82 = { class: "flex items-center space-x-3" }
const _hoisted_83 = { class: "min-w-0" }
const _hoisted_84 = { class: "font-medium text-gray-900 text-sm truncate" }
const _hoisted_85 = {
  key: 0,
  class: "px-2 py-1 bg-gradient-to-r from-green-500 to-emerald-500 text-white text-xs font-medium rounded-full"
}
const _hoisted_86 = { class: "bg-white rounded-lg py-3 px-4 shadow-sm border border-gray-200" }
const _hoisted_87 = { class: "bg-gray-50 rounded-lg p-3 border border-gray-200" }
const _hoisted_88 = { class: "text-gray-800 text-sm leading-relaxed" }

import type { FormSummaryProps } from "../../types/sellerRegister";


export default /*@__PURE__*/_defineComponent({
  __name: 'FormSummary',
  props: {
    title: {},
    subtitle: {},
    data: {},
    priceRange: {},
    bankingInfo: {},
    logoFile: {}
  },
  setup(__props: any) {

const props = __props;

const formatBrands = () => {
  const brands = props.data.brand;
  if (brands && brands.length > 0) {
    return brands.join(", ");
  }
  return "Aucune marque sélectionnée";
};

const formatContact = () => {
  const { contactName, firstName } = props.data;
  if (contactName && firstName) {
    return `${contactName} ${firstName}`;
  } else if (contactName) {
    return contactName;
  } else if (firstName) {
    return firstName;
  }
  return "Non renseigné";
};

const formatCategories = () => {
  const categories = props.data.productCategories;
  if (categories && categories.length > 0) {
    return `${categories.length} catégorie(s) sélectionnée(s)`;
  }
  return "Aucune catégorie sélectionnée";
};

const formatPriceRange = () => {
  if (props.priceRange) {
    const { min, max } = props.priceRange;
    if (min !== undefined && max !== undefined) {
      return `${min}€ - ${max}€`;
    }
  }
  return "Non renseigné";
};
const formatFileName = (file: File) => {
  if (!file) return "Fichier inconnu";

  // Afficher le nom du fichier avec sa taille
  const sizeInKB = Math.round(file.size / 1024);
  const sizeText =
    sizeInKB > 1024 ? `${Math.round(sizeInKB / 1024)} MB` : `${sizeInKB} KB`;

  return `${file.name} (${sizeText})`;
};

// Vérifier si le fichier est une image
const isImageFile = (file: File): boolean => {
  return file.type.startsWith("image/");
};

// Créer un aperçu de l'image
const getImagePreview = (file: File): string => {
  if (!isImageFile(file)) return "";

  // Créer une URL temporaire pour l'aperçu
  return URL.createObjectURL(file);
};

// Formater la taille du fichier
const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "inline-flex items-center justify-center w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full mb-2" }, [
        _createElementVNode("i", { class: "fas fa-clipboard-check text-white text-lg" })
      ], -1)),
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.title), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.subtitle), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _cache[17] || (_cache[17] = _createElementVNode("div", { class: "flex items-center space-x-2 mb-2" }, [
          _createElementVNode("div", { class: "w-8 h-8 bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg flex items-center justify-center" }, [
            _createElementVNode("i", { class: "fas fa-building text-white text-sm" })
          ]),
          _createElementVNode("h4", { class: "text-base font-semibold text-gray-900" }, " Informations générales ")
        ], -1)),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fas fa-building text-blue-600 w-4 text-xs hidden sm:block" }, null, -1)),
            _createElementVNode("div", _hoisted_9, [
              _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-xs text-gray-600 mb-0" }, "Société", -1)),
              _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.data.companyName || "Non renseigné"), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _cache[4] || (_cache[4] = _createElementVNode("i", { class: "fas fa-tags text-purple-600 w-4 text-xs hidden sm:block" }, null, -1)),
            _createElementVNode("div", _hoisted_12, [
              _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-xs text-gray-600 mb-0" }, "Marques", -1)),
              _createElementVNode("p", _hoisted_13, _toDisplayString(formatBrands()), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fas fa-user text-green-600 w-4 text-xs hidden sm:block" }, null, -1)),
            _createElementVNode("div", _hoisted_15, [
              _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-xs text-gray-600 mb-0" }, "Contact", -1)),
              _createElementVNode("p", _hoisted_16, _toDisplayString(formatContact()), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _cache[8] || (_cache[8] = _createElementVNode("i", { class: "fas fa-envelope text-orange-600 w-4 text-xs hidden sm:block" }, null, -1)),
            _createElementVNode("div", _hoisted_18, [
              _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-xs text-gray-600 mb-0" }, "Email", -1)),
              _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.data.email || "Non renseigné"), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _cache[10] || (_cache[10] = _createElementVNode("i", { class: "fas fa-phone text-indigo-600 w-4 text-xs hidden sm:block" }, null, -1)),
            _createElementVNode("div", _hoisted_21, [
              _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-xs text-gray-600 mb-0" }, "Téléphone", -1)),
              _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.data.phone || "Non renseigné"), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _cache[12] || (_cache[12] = _createElementVNode("i", { class: "fas fa-mobile-alt text-pink-600 w-4 text-xs hidden sm:block" }, null, -1)),
            _createElementVNode("div", _hoisted_24, [
              _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-xs text-gray-600 mb-0" }, "Mobile", -1)),
              _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.data.mobile || "Non renseigné"), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _cache[14] || (_cache[14] = _createElementVNode("i", { class: "fas fa-fax text-teal-600 w-4 text-xs hidden sm:block" }, null, -1)),
            _createElementVNode("div", _hoisted_27, [
              _cache[13] || (_cache[13] = _createElementVNode("p", { class: "text-xs text-gray-600 mb-0" }, "Fax", -1)),
              _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.data.fax || "Non renseigné"), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _cache[16] || (_cache[16] = _createElementVNode("i", { class: "fas fa-calendar text-amber-600 w-4 text-xs hidden sm:block" }, null, -1)),
            _createElementVNode("div", _hoisted_30, [
              _cache[15] || (_cache[15] = _createElementVNode("p", { class: "text-xs text-gray-600 mb-0" }, "Création", -1)),
              _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.data.creationDate || "Non renseigné"), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("div", _hoisted_33, [
          _cache[19] || (_cache[19] = _createElementVNode("div", { class: "flex items-center space-x-2 mb-2" }, [
            _createElementVNode("div", { class: "w-8 h-8 bg-gradient-to-br from-yellow-500 to-orange-500 rounded-lg flex items-center justify-center" }, [
              _createElementVNode("i", { class: "fas fa-image text-white text-sm" })
            ]),
            _createElementVNode("h4", { class: "text-base font-semibold text-gray-900" }, "Logo")
          ], -1)),
          (_ctx.logoFile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _createElementVNode("img", {
                  src: getImagePreview(_ctx.logoFile),
                  alt: _ctx.logoFile.name,
                  class: "w-48 h-48 object-cover rounded-lg border-2 border-gray-200 shadow-sm"
                }, null, 8, _hoisted_35),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.logoFile.name), 1),
                  _createElementVNode("p", _hoisted_38, _toDisplayString(formatFileSize(_ctx.logoFile.size)), 1)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_39, _cache[18] || (_cache[18] = [
                _createElementVNode("i", { class: "fas fa-image text-gray-300 text-2xl mb-1" }, null, -1),
                _createElementVNode("p", { class: "text-xs text-gray-500" }, "Aucun logo", -1)
              ])))
        ]),
        _createElementVNode("div", _hoisted_40, [
          _cache[26] || (_cache[26] = _createElementVNode("div", { class: "flex items-center space-x-2 mb-2" }, [
            _createElementVNode("div", { class: "w-8 h-8 bg-gradient-to-br from-green-500 to-emerald-600 rounded-lg flex items-center justify-center" }, [
              _createElementVNode("i", { class: "fas fa-map-marker-alt text-white text-sm" })
            ]),
            _createElementVNode("h4", { class: "text-base font-semibold text-gray-900" }, "Localisation")
          ], -1)),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _cache[21] || (_cache[21] = _createElementVNode("i", { class: "fas fa-road text-green-600 w-4 text-xs hidden sm:block" }, null, -1)),
              _createElementVNode("div", _hoisted_43, [
                _cache[20] || (_cache[20] = _createElementVNode("p", { class: "text-xs text-gray-600 mb-0" }, "Rue", -1)),
                _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.data.streetAddress || "Non renseigné"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _cache[23] || (_cache[23] = _createElementVNode("i", { class: "fas fa-mail-bulk text-green-600 w-4 text-xs hidden sm:block" }, null, -1)),
              _createElementVNode("div", _hoisted_46, [
                _cache[22] || (_cache[22] = _createElementVNode("p", { class: "text-xs text-gray-600 mb-0" }, "Code postal", -1)),
                _createElementVNode("p", _hoisted_47, _toDisplayString(_ctx.data.postalCode || "Non renseigné"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_48, [
              _cache[25] || (_cache[25] = _createElementVNode("i", { class: "fas fa-city text-green-600 w-4 text-xs hidden sm:block" }, null, -1)),
              _createElementVNode("div", _hoisted_49, [
                _cache[24] || (_cache[24] = _createElementVNode("p", { class: "text-xs text-gray-600 mb-0" }, "Ville", -1)),
                _createElementVNode("p", _hoisted_50, _toDisplayString(_ctx.data.city || "Non renseigné"), 1)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_51, [
        _createElementVNode("div", _hoisted_52, [
          _cache[33] || (_cache[33] = _createElementVNode("div", { class: "flex items-center space-x-2 mb-2" }, [
            _createElementVNode("div", { class: "w-8 h-8 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-lg flex items-center justify-center" }, [
              _createElementVNode("i", { class: "fas fa-university text-white text-sm" })
            ]),
            _createElementVNode("h4", { class: "text-base font-semibold text-gray-900" }, " Informations bancaires ")
          ], -1)),
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _cache[28] || (_cache[28] = _createElementVNode("i", { class: "fas fa-user-circle text-blue-600 w-4 text-xs hidden sm:block" }, null, -1)),
              _createElementVNode("div", _hoisted_55, [
                _cache[27] || (_cache[27] = _createElementVNode("p", { class: "text-xs text-gray-600 mb-0" }, "Titulaire du compte", -1)),
                _createElementVNode("p", _hoisted_56, _toDisplayString(_ctx.bankingInfo?.accountTitle || "Non renseigné"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_57, [
              _cache[30] || (_cache[30] = _createElementVNode("i", { class: "fas fa-credit-card text-emerald-600 w-4 text-xs hidden sm:block" }, null, -1)),
              _createElementVNode("div", _hoisted_58, [
                _cache[29] || (_cache[29] = _createElementVNode("p", { class: "text-xs text-gray-600 mb-0" }, "IBAN", -1)),
                _createElementVNode("p", _hoisted_59, _toDisplayString(_ctx.bankingInfo?.iban || "Non renseigné"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_60, [
              _cache[32] || (_cache[32] = _createElementVNode("i", { class: "fas fa-receipt text-cyan-600 w-4 text-xs hidden sm:block" }, null, -1)),
              _createElementVNode("div", _hoisted_61, [
                _cache[31] || (_cache[31] = _createElementVNode("p", { class: "text-xs text-gray-600 mb-0" }, "TVA", -1)),
                _createElementVNode("p", _hoisted_62, _toDisplayString(_ctx.bankingInfo?.tva || "Non renseigné"), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_63, [
          _cache[40] || (_cache[40] = _createElementVNode("div", { class: "flex items-center space-x-2 mb-2" }, [
            _createElementVNode("div", { class: "w-8 h-8 bg-gradient-to-br from-purple-500 to-violet-600 rounded-lg flex items-center justify-center" }, [
              _createElementVNode("i", { class: "fas fa-chart-line text-white text-sm" })
            ]),
            _createElementVNode("h4", { class: "text-base font-semibold text-gray-900" }, " Informations commerciales ")
          ], -1)),
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("div", _hoisted_65, [
              _cache[35] || (_cache[35] = _createElementVNode("i", { class: "fas fa-th-large text-purple-600 w-4 text-xs hidden sm:block" }, null, -1)),
              _createElementVNode("div", _hoisted_66, [
                _cache[34] || (_cache[34] = _createElementVNode("p", { class: "text-xs text-gray-600 mb-0" }, "Catégories", -1)),
                _createElementVNode("p", _hoisted_67, _toDisplayString(formatCategories()), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_68, [
              _cache[37] || (_cache[37] = _createElementVNode("i", { class: "fas fa-euro-sign text-violet-600 w-4 text-xs hidden sm:block" }, null, -1)),
              _createElementVNode("div", _hoisted_69, [
                _cache[36] || (_cache[36] = _createElementVNode("p", { class: "text-xs text-gray-600 mb-0" }, "Gamme de prix", -1)),
                _createElementVNode("p", _hoisted_70, _toDisplayString(formatPriceRange()), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_71, [
              _cache[39] || (_cache[39] = _createElementVNode("i", { class: "fas fa-shopping-cart text-indigo-600 w-4 text-xs hidden sm:block" }, null, -1)),
              _createElementVNode("div", _hoisted_72, [
                _cache[38] || (_cache[38] = _createElementVNode("p", { class: "text-xs text-gray-600 mb-0" }, "Min. commande", -1)),
                _createElementVNode("p", _hoisted_73, _toDisplayString(_ctx.data.minOrder || "Non renseigné"), 1)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_74, [
        _cache[47] || (_cache[47] = _createElementVNode("div", { class: "flex items-center space-x-2 mb-2" }, [
          _createElementVNode("div", { class: "w-8 h-8 bg-gradient-to-br from-red-500 to-pink-600 rounded-lg flex items-center justify-center" }, [
            _createElementVNode("i", { class: "fas fa-file-alt text-white text-sm" })
          ]),
          _createElementVNode("h4", { class: "text-base font-semibold text-gray-900" }, "Documents")
        ], -1)),
        _createElementVNode("div", _hoisted_75, [
          _createElementVNode("div", _hoisted_76, [
            _createElementVNode("div", _hoisted_77, [
              _cache[42] || (_cache[42] = _createElementVNode("div", { class: "document-icon hidden sm:flex w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg items-center justify-center" }, [
                _createElementVNode("i", { class: "fas fa-file-pdf text-white text-lg" })
              ], -1)),
              _createElementVNode("div", _hoisted_78, [
                _cache[41] || (_cache[41] = _createElementVNode("p", { class: "font-semibold text-blue-900 text-sm" }, "Kbis", -1)),
                _createElementVNode("p", _hoisted_79, _toDisplayString(_ctx.data.kbis ? formatFileName(_ctx.data.kbis) : "Aucun document"), 1)
              ])
            ]),
            (_ctx.data.kbis)
              ? (_openBlock(), _createElementBlock("div", _hoisted_80, _cache[43] || (_cache[43] = [
                  _createElementVNode("i", { class: "fas fa-check text-xs mr-1" }, null, -1),
                  _createTextVNode("OK ")
                ])))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_81, [
            _createElementVNode("div", _hoisted_82, [
              _cache[45] || (_cache[45] = _createElementVNode("div", { class: "document-icon hidden sm:flex w-10 h-10 bg-gradient-to-br from-green-500 to-emerald-600 rounded-lg items-center justify-center" }, [
                _createElementVNode("i", { class: "fas fa-id-card text-white text-lg" })
              ], -1)),
              _createElementVNode("div", _hoisted_83, [
                _cache[44] || (_cache[44] = _createElementVNode("p", { class: "font-semibold text-green-900 text-sm" }, "ID Gérant", -1)),
                _createElementVNode("p", _hoisted_84, _toDisplayString(_ctx.data.idGerant
                      ? formatFileName(_ctx.data.idGerant)
                      : "Aucun document"), 1)
              ])
            ]),
            (_ctx.data.idGerant)
              ? (_openBlock(), _createElementBlock("div", _hoisted_85, _cache[46] || (_cache[46] = [
                  _createElementVNode("i", { class: "fas fa-check text-xs mr-1" }, null, -1),
                  _createTextVNode("OK ")
                ])))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_86, [
        _cache[48] || (_cache[48] = _createElementVNode("div", { class: "flex items-center space-x-2 mb-2" }, [
          _createElementVNode("div", { class: "w-8 h-8 bg-gradient-to-br from-amber-500 to-orange-600 rounded-lg flex items-center justify-center" }, [
            _createElementVNode("i", { class: "fas fa-align-left text-white text-sm" })
          ]),
          _createElementVNode("h4", { class: "text-base font-semibold text-gray-900" }, "Description")
        ], -1)),
        _createElementVNode("div", _hoisted_87, [
          _createElementVNode("p", _hoisted_88, _toDisplayString(_ctx.data.description || "Aucune description fournie"), 1)
        ])
      ])
    ])
  ]))
}
}

})